// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__2U_Zq","inner":"Page_inner__3RI8d","centered":"Page_centered__16hVM","content":"Page_content__2kYv6","specialMode":"Page_specialMode__2w0VQ"};